import { c as _c } from "react/compiler-runtime";
import React, { FunctionComponent } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ForgotPasswordForm } from 'record-it-components/form/ForgotPasswordForm/ForgotPasswordForm';
import { useEventCallback } from 'record-it-components/hooks/useEventCallback';
import { prepareProps } from 'record-it-components/utils/propUtils';
import { PropsWithoutChildren } from 'record-it-components/utils/utilityTypes';
import { ApiAdapter } from '../../../classes/ApiAdapter/ApiAdapter';
import { RoutePaths } from '../../../classes/RoutePaths/RoutePaths';
export type ForgotPasswordPageProps = PropsWithoutChildren<Record<never, never>>;
export const ForgotPasswordPage: FunctionComponent<ForgotPasswordPageProps> = React.memo(props => {
  const $ = _c(8);
  prepareProps({
    props,
    ignoreChildren: true
  });
  const [params] = useSearchParams();
  let t0;
  if ($[0] !== params) {
    t0 = params.get("email") ?? "";
    $[0] = params;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const emailParam = t0;
  const navigate = useNavigate();
  const sendPasswordResetEmail = useEventCallback(_temp);
  let t1;
  if ($[2] !== navigate) {
    t1 = () => {
      navigate(RoutePaths.loginPage());
    };
    $[2] = navigate;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleCancel = useEventCallback(t1);
  let t2;
  if ($[4] !== emailParam || $[5] !== handleCancel || $[6] !== sendPasswordResetEmail) {
    t2 = <ForgotPasswordForm sendPasswortResetMail={sendPasswordResetEmail} onCancel={handleCancel} key={emailParam} defaultEmail={emailParam} data-testid="ForgotPasswordPage.Form" />;
    $[4] = emailParam;
    $[5] = handleCancel;
    $[6] = sendPasswordResetEmail;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
});
async function _temp(email) {
  const response = await ApiAdapter.sendPasswordResetEmail({
    email
  });
  if (response.success === false) {
    throw new Error(response.message);
  }
}